'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import SuggestedMessages from '../SuggestedMessages'
import usePostReply from '../../hooks/usePostReply/usePostReply'
import { SUGGESTED_MESSAGES } from './constants'

const SvcMessagingSuggestedMessages = () => {
  const { conversation } = useConversationContext()
  const { postReplyRequest } = usePostReply()
  const translate = useTranslate()

  if (!conversation?.showSuggestedMessagesForSeller) return null

  return (
    <SuggestedMessages
      messages={SUGGESTED_MESSAGES.map((translationKey, index) => ({
        id: index + 1,
        text: translate(translationKey),
      }))}
      onMessageClick={value => postReplyRequest({ value })}
      trackingContext={{
        transactionId: conversation.transactionId,
        // TODO: order.itemIds won't be available in `svc-messaging`
        itemIds: conversation.transaction?.order?.itemIds.toString(),
      }}
    />
  )
}

export default SvcMessagingSuggestedMessages
